//<!-- ========================================================================================== -->
//<!-- Scripts to handle the CAROUSEL                                                             -->
//<!-- ========================================================================================== -->       

//{{-- Carousel swipe functions for touchscreen --}}
//{{-- Thanks to Maaaaark - https://{{--github.com/maaaaark/bcSwipe/blob/master/jquery.bcSwipe.min.js --}}
! function (t) {
    t.fn.bcSwipe = function (e) {
        var n = {
            threshold: 30
        };
        return e && t.extend(n, e), this.each(function () {
            function e(t) {
                1 == t.touches.length && (u = t.touches[0].pageX, c = !0, this.addEventListener("touchmove", o, !1))
            }
            function o(e) {
                if (c) {
                    var o = e.touches[0].pageX,
                        i = u - o;
                    Math.abs(i) >= n.threshold && (h(), swipe(i,-1))
                }
            }
            function h() {
                this.removeEventListener("touchmove", o), u = null, c = !1
            }
            var u, c = !1;
            "ontouchstart" in document.documentElement && this.addEventListener("touchstart", e, !1)
        }), this
    }
}($);
    
$('#myCarousel').bcSwipe({ threshold: 30 });

//{{-- Swipe function for mouse --}}
$('.my-swipe-container').safeOn('dragstart', function(event) {            
    event.preventDefault();
    var startX = event.pageX;                
    $('.my-swipe-container').safeOn('mouseup', function(event) {
        if(startX > 0) { 
            //{{-- we're doing this because we couldn't get the dragstop event to bind... --}}
            var distance = event.pageX - startX;
            if (Math.abs(distance) > 30) {
                swipe(distance, -1);
            }
            startX = 0;
            $(this).off('mouseup');
        }
    })
});

function swipe(deltaX, file){
    //{{-- Does the swipe   --}}
    //{{-- 1. Get your bearings  --}}
    var direction = (deltaX > 0) ? "next" : "prev";             

    //{{-- 2. Swipe  --}}
    $('.my-swipe-container').carousel(direction);                        
    
}

//{{-- Normalize carousel height by its tallest slide --}}
//{{-- A slide's real height is only determined after it is shown, so we have to keep calculating the talles slide as they pass --}}
var tallest = 0;

$(function(){

    normalizeCarousel();

    $(window).on('resize orientationchange', function(evt) {
        evt.stopImmediatePropagation();
        tallest = 0;
        $('.carousel-inner').css('min-height', tallest);
        normalizeCarousel();
    });
    $('.my-swipe-container').safeOn('slid.bs.carousel', function (evt) {        //{{-- keep track of the tallest carousel item --}}
        evt.stopImmediatePropagation();
        normalizeCarousel();
    });
    
});

function normalizeCarousel() {
    var height = $(".carousel-inner").height();
    if (height > tallest) {
        tallest = height;
        $('.carousel-inner').css('min-height', tallest);                     //{{-- reset min-height for all carousel items --}}
    }
}
